import { TEDEKBokforderTYPEnum } from '../../../../../../globalQueryTypes';
import { FranvaroReservForQuery_db_SYSFranvaro_All } from '../../../../SystemAdministration/ObjektVyer/User/Components/FranvaroReservFor/Queries/_QueryTypes/FranvaroReservForQuery';
import {
  IFieldValidation,
  IFormData,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { IBokforderKodbehorigheter } from '../../../../_Common/Components/KonteringManager/KonteringContext';
import { IKodstrang } from '../../../../_Common/Components/KonteringManager/KonteringManager';
import { IKontodelDef } from '../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import { IUserBokforderKodbehorigheter } from '../Components/BokforderContext/BokforderContextManager';
import {
  BokforderType__Associations_Rader,
  BokforderType__Associations_Rader__Associations_Kontodel1,
} from '../Queries/_QueryTypes/BokforderType';
import {
  filterUsersOnKodstrang,
  findFranvaroForUser,
  getUserKodbehsBasedOnKodstrang,
} from './BokforderUtils';

export enum isInternkontoEnum {
  NotSet = -1,
  False = 0,
  True = 1,
}

export const mixedInternAndExternKonton = (
  selectedBaskonton: (
    | BokforderType__Associations_Rader__Associations_Kontodel1
    | null
    | undefined
  )[],
  baskontoDelsDef: IKontodelDef | undefined
) => {
  let isInternkonto = isInternkontoEnum.NotSet;
  let result = false;
  for (let index = 0; index < selectedBaskonton.length; index++) {
    const selectedBaskonto = selectedBaskonton[index];
    if (selectedBaskonto) {
      let selectedBaskontoId = '';
      if (typeof selectedBaskonto === 'string') {
        selectedBaskontoId = selectedBaskonto;
      } else {
        selectedBaskontoId = selectedBaskonto.id;
      }
      const baskontoDetailed = baskontoDelsDef?.kontodelar.find(
        baskontoFromKodplan => baskontoFromKodplan.id === selectedBaskontoId
      );

      if (baskontoDetailed?.internKonto) {
        if (isInternkonto === isInternkontoEnum.False) {
          result = true;
          break;
        } else if (isInternkonto === isInternkontoEnum.NotSet) {
          isInternkonto = isInternkontoEnum.True;
        }
      } else {
        if (isInternkonto === isInternkontoEnum.True) {
          result = true;
          break;
        } else {
          isInternkonto = isInternkontoEnum.False;
        }
      }
    }
  }
  return result;
};

export const getKontrollAndReserveNotAllowedError = (
  isBestallare: boolean,
  haveAttestantOnRows: boolean,
  reservForKontrollattestant:
    | FranvaroReservForQuery_db_SYSFranvaro_All
    | undefined,
  haveAttesteratAsReserveOrAttestant: boolean
) => {
  if (
    (isBestallare || haveAttesteratAsReserveOrAttestant) &&
    haveAttestantOnRows &&
    reservForKontrollattestant != undefined
  ) {
    const error: IFieldValidation = {
      fieldName: 'Kontrollattestant',
      type: 'Error',
      message:
        'Det är ej tillåtet att attestera som reserv för kontrollattestant när du är attestant, reserv för attestant eller beställare',
    };

    return error;
  }
  return undefined;
};

export const getKontrollAttestantIsRequiredError = (
  atleastOneBeslutsattestantHaveKontrollbeloppBelowBelopp: boolean,
  haveAttestantOnRows: boolean,
  isBestallare: boolean,
  isKontrollattestantFieldTouched: boolean,
  kontrollattestantKodbeh: undefined,
  onlyOnePersonInvolved: boolean
) => {
  if (
    kontrollattestantKodbeh === undefined &&
    (onlyOnePersonInvolved ||
      atleastOneBeslutsattestantHaveKontrollbeloppBelowBelopp) &&
    haveAttestantOnRows
  ) {
    const error: IFieldValidation = {
      fieldName: 'Kontrollattestant',
      type:
        atleastOneBeslutsattestantHaveKontrollbeloppBelowBelopp &&
        isBestallare &&
        !onlyOnePersonInvolved
          ? 'Warning'
          : 'RequiredValueHint',
      showAsHint: !isKontrollattestantFieldTouched,
      message: 'Kontrollattestant krävs',
    };

    return error;
  }
  return undefined;
};

export const validateKontrollattestant = (
  rows: BokforderType__Associations_Rader[],
  touched: IFormData | undefined,
  kontrollattestantKodbeh: IUserBokforderKodbehorigheter | undefined,
  isBestallare: boolean,
  belopp: number,
  allUtanordningUsersWithKodbeh: IUserBokforderKodbehorigheter[],
  kodstrangar: IKodstrang[],
  userID: string | null,
  bestallareID: string | undefined,
  franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[],
  validKontrollattestanter: IUserBokforderKodbehorigheter[]
): IFieldValidation[] => {
  const validations: IFieldValidation[] = [];
  const today = new Date();

  const atleastOneBeslutsattestantHaveKontrollbeloppBelowBelopp = rows.some(
    row => {
      const beslutsattestant = allUtanordningUsersWithKodbeh.find(
        user => user.userID === (row._Associations?.Attestant?.id ?? '')
      );

      if (beslutsattestant) {
        const haveKontrollbeloppBelowBelopp =
          beslutsattestant.bokforderkodbehorigheter?.some(
            kodbeh =>
              kodbeh?.UTANORDNING_KONTROLLBELOPP &&
              kodbeh?.UTANORDNING_KONTROLLBELOPP < (belopp ?? 0)
          );

        return haveKontrollbeloppBelowBelopp;
      }
      return false;
    }
  );

  // Denna variabel är när personen som är inne är beställare
  const isBestallareAndOnlyAttestant =
    isBestallare &&
    rows
      .filter(row => row._Associations?.Attestant?.id != null)
      .every(row => {
        return (
          row._Associations?.Attestant?.id === userID ||
          row._Associations?.Reserv?.id === userID ||
          franvaroReservForData.some(franvaro =>
            findFranvaroForUser(
              row._Associations?.Attestant?.id,
              TEDEKBokforderTYPEnum.UTANORDNING,
              today,
              franvaro
            )
          )
        );
      });

  // Denna variabel hanterar när tex kontrollattestanten är inne och vi måste se om beställare och attestant är samma person
  const bestallareAndAttestantIsOnePerson =
    bestallareID != undefined &&
    rows
      .filter(row => row._Associations?.Attestant?.id != null)
      .every(
        row =>
          row._Associations?.Attestant?.id === bestallareID ||
          row._Associations?.Reserv?.id === bestallareID
      );

  const haveAttesteratAsReserveOrAttestant = rows.some(
    row =>
      (row._Associations?.Attestant?.id === userID ||
        row._Associations?.Reserv?.id === userID) &&
      row.ATTESTERAD_DATUM != null
  );

  const onlyOnePersonInvolved =
    isBestallareAndOnlyAttestant || bestallareAndAttestantIsOnePerson;

  const haveAttestantOnRows = rows.some(
    row =>
      row._Associations?.Attestant?.id != null &&
      row._Associations?.Attestant?.id != ''
  );

  if (kontrollattestantKodbeh) {
    const reservForKontrollattestant = franvaroReservForData.find(franvaro =>
      findFranvaroForUser(
        kontrollattestantKodbeh.userID,
        TEDEKBokforderTYPEnum.UTANORDNING,
        today,
        franvaro
      )
    );

    const franvaroError = getKontrollAndReserveNotAllowedError(
      isBestallare,
      haveAttestantOnRows,
      reservForKontrollattestant,
      haveAttesteratAsReserveOrAttestant
    );

    if (franvaroError !== undefined) {
      validations.push(franvaroError);

      return validations;
    }

    const kontrollattestantIsPickedOnRow =
      rows.filter(
        row =>
          row._Associations?.Attestant?.id === kontrollattestantKodbeh.userID
      ).length != 0;

    if (kontrollattestantIsPickedOnRow) {
      const error: IFieldValidation = {
        fieldName: 'Kontrollattestant',
        type: 'Error',
        message:
          'Kontrollattestanten kan inte vara kontrollattestant och attestant på rad',
      };

      validations.push(error);
    }

    const kodbehValidOnEveryRow = kodstrangar.every(currentKodstrang => {
      return filterUsersOnKodstrang(currentKodstrang.kontodelar)(
        kontrollattestantKodbeh
      );
    });

    if (!kodbehValidOnEveryRow) {
      const error: IFieldValidation = {
        fieldName: 'Kontrollattestant',
        type: 'Error',
        message:
          'Kontrollattestanten är inte behörig till samtliga rader på utanordningen',
      };

      validations.push(error);
    }

    const kontrollKodbehs: IBokforderKodbehorigheter[] =
      getUserKodbehsBasedOnKodstrang(kodstrangar, kontrollattestantKodbeh);

    const beloppInRangeForAtLeastOneKodbeh = kontrollKodbehs.some(kodbeh => {
      if (kodbeh) {
        return (
          kodbeh.UTANORDNING_KA_MAXBELOPP == null ||
          (kodbeh.UTANORDNING_KA_MAXBELOPP &&
            kodbeh.UTANORDNING_KA_MAXBELOPP >= (belopp ?? 0))
        );
      }
      return false;
    });
    if (!beloppInRangeForAtLeastOneKodbeh) {
      const error: IFieldValidation = {
        fieldName: 'Kontrollattestant',
        type: 'Error',
        showAsHint: !touched?.Kontrollattestant,
        message: 'Beloppet överstiger kontrollattestantens maxbelopp',
      };

      validations.push(error);
    }

    if (isBestallare && kontrollattestantKodbeh.userID === userID) {
      const error: IFieldValidation = {
        fieldName: 'Kontrollattestant',
        type: 'Error',
        message:
          'Kontrollattestanten kan inte vara kontrollattestant och beställare',
      };

      validations.push(error);
    }

    return validations;
  }

  const requiredError = getKontrollAttestantIsRequiredError(
    atleastOneBeslutsattestantHaveKontrollbeloppBelowBelopp,
    haveAttestantOnRows,
    isBestallare,
    Boolean(touched?.Kontrollattestant),
    kontrollattestantKodbeh,
    onlyOnePersonInvolved
  );

  if (requiredError !== undefined) {
    if (validKontrollattestanter.length === 0) {
      const error: IFieldValidation = {
        fieldName: 'Kontrollattestant',
        type:
          atleastOneBeslutsattestantHaveKontrollbeloppBelowBelopp &&
          isBestallare &&
          !onlyOnePersonInvolved
            ? 'Warning'
            : 'Error',
        showAsHint: false,
        message:
          'Det saknas kontrollattestanter med behörighet för denna utanordning',
      };

      return [error];
    }

    validations.push(requiredError);

    return validations;
  }

  return validations;
};
